import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import basic from "@/data/forms/mixins/basic.js";
import char from "@/data/forms/mixins/char.js";
import stats from "@/data/forms/mixins/stats.js";
// import action from "@/data/forms/mixins/action.js";
// import short from "@/data/forms/mixins/short.js";
import generateLog from "@/document/log/mixins/generateLog.js";
import relps from "@/data/forms/mixins/relps.js";
import statsMods from "@/support/stats/mixins/statsMods.js";
export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getDataPrivacy",
      // "getMaintStrategy",
      "getDetail",
      "getAction",
      "getRoleAssigneeDIDCurrent",
      "getRoleAssigneeDIDPrevious",
      "getTransitionStatusCurrent",
      "getTransitionStatusPrevious"
    ])
  },
  mixins: [basic, char, stats, relps, generateLog, statsMods],
  data() {
    return {
      tempAction: null
    };
  },
  methods: {
    userUpdatedSnackbarCustom(colour, text) {
      let snackbarInfo = {
        enable: true,
        color: colour,
        timeout: 5000,
        text: text,
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    updateActionForUser() {
      let assigneeDIDOld = this.getRoleAssigneeDIDPrevious;
      let assigneeDIDNew = this.getRoleAssigneeDIDCurrent;
      let statusOld = this.getTransitionStatusPrevious;
      let statusNew = this.getTransitionStatusCurrent;
      let closed = false;

      // USER ACTION MAKE SAVE = TRUE
      let tempAction = this.getDetail;
      tempAction.basic.save = true;

      if (assigneeDIDOld === null && assigneeDIDNew === null) {
        assigneeDIDOld = this.getDetailRelps.g4[0].user.udid;
        assigneeDIDNew = this.getDetailRelps.g4[0].user.udid;
      }

      // CHECK if ACTION IS CLOSED
      if (statusOld === "Completed" && statusNew === "Closed") {
        closed = true;
      } else if (statusOld === "Closed" && statusNew === "Closed") {
        closed = true;
      } else {
        closed = false;
      }
      console.log("");
      console.log("............................................");
      console.log("ACTION VERIFY");
      console.log("Assignee Old " + assigneeDIDOld);
      console.log("Assignee New " + assigneeDIDNew);
      console.log("Status Old " + statusOld);
      console.log("Status New " + statusNew);
      console.log("............................................");
      console.log("");

      // CASE 1 NEW ASSIGNEE AND ACTION IS OPEN
      if (assigneeDIDOld === "" && assigneeDIDNew !== "" && closed !== true) {
        console.log("");
        console.log("<<< NEW USER >>>");
        console.log("");
        // DEFINE USER
        let udid = this.getRoleAssigneeDIDCurrent;
        // USER DID for ACTIONEE (differnt to you)
        this.$store.dispatch("changeUserDID", udid);
        // GENERATE USER LOG
        this.generateActionAssigneeLog(tempAction, "was assigned.", udid);
        // UPDATE USER STATS
        this.updateUserStatsNewDoc(tempAction);
        // this.updateUserStatsOpen(tempAction, udid, true);
        // CREATE USER ACTION
        this.setActionForUser(tempAction, udid);
        // this.generateLog("U1", "Action", "was assigned.", tempAction);
        // this.$store.dispatch("changeUserDID", this.getRoleAssigneeDIDCurrent);
        // this.createFirebaseDocumentLog("U1");
      }
      // CASE 3 RESET USER
      if (assigneeDIDOld !== "" && assigneeDIDNew === "" && closed !== true) {
        console.log("");
        console.log("<<< RESET USER >>>");
        console.log("");
        // DEFINE USER
        let udid = this.getRoleAssigneeDIDPrevious;
        // USER DID for ACTIONEE (differnt to you)
        this.$store.dispatch("changeUserDID", udid);
        // UPDATE USER STATS
        this.updateUserStatsCloseDoc(tempAction);
        // GENERATE USER LOG
        this.generateActionAssigneeLog(tempAction, "was removed.", udid);
        // DELETE USER ACTION
        this.deleteActionForUser(tempAction, udid);
      }
      // CASE 3 TRANSFER OF ASSIGNEE AND ACTION IS OPEN
      if (
        assigneeDIDOld !== assigneeDIDNew &&
        assigneeDIDOld !== "" &&
        assigneeDIDNew !== "" &&
        closed !== true
      ) {
        console.log("");
        console.log("<<< TRANSFER USER >>>");
        console.log("");
        // DELETE OLD USER ACTION
        let udid = this.getRoleAssigneeDIDPrevious;
        // USER DID for ACTIONEE (differnt to you)
        this.$store.dispatch("changeUserDID", udid);
        // UPDATE USER STATS
        this.updateUserStatsCloseDoc(tempAction);
        // GENERATE USER LOG
        this.generateActionAssigneeLog(tempAction, "was removed.", udid);
        // DELETE USER ACTION
        this.deleteActionForUser(tempAction, udid);

        // GENERATE NEW USER ACTION
        // DEFINE USER
        udid = this.getRoleAssigneeDIDCurrent;
        // USER DID for ACTIONEE (differnt to you)
        this.$store.dispatch("changeUserDID", udid);
        // UPDATE USER STATS
        this.updateUserStatsNewDoc(tempAction);
        // GENERATE USER LOG
        this.generateActionAssigneeLog(tempAction, "was assigned.", udid);
        // CREATE USER ACTION for NEW USER
        this.setActionForUser(tempAction, udid);
      }
      // CASE 4 CASE CLOSED (MUST HAVE USER SELECT UDID IS NOT NULL)
      if (
        assigneeDIDOld !== "" &&
        assigneeDIDNew !== "" &&
        statusOld !== statusNew &&
        closed === true
      ) {
        console.log("<<< ACTION CLOSED >>>");
        console.log("");
        // DEFINE USER
        let udid = this.getRoleAssigneeDIDCurrent;
        // USER DID for ACTIONEE (differnt to you)
        this.$store.dispatch("changeUserDID", udid);
        // UPDATE USER STATS
        this.updateUserStatsCloseDoc(tempAction);
        // UPDATE USER STATS
        this.updateCompanyStatsCloseDoc(tempAction);
        // GENERATE USER LOG
        this.generateActionAssigneeLog(tempAction, "was closed.", udid);
        // current user
        this.deleteActionForUser(tempAction, udid);
      }
    },
    setActionForUser(action, udid) {
      let did = action.basic.did;
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("person").doc(udid).collection("action");
      // eslint-disable-next-line
      dbUserActions.doc(did).set(action).then(function(docRef) {});
    },
    deleteActionForUser(action, udid) {
      console.log(">>> DELETE ACTION for USER <<<");
      console.log(action);
      console.log(udid);
      let did = action.basic.did;
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("person").doc(udid).collection("action");
      // eslint-disable-next-line
      dbUserActions.doc(did).delete().then(function(docRef) {});
    },
    createActionForUserLEGACY(u) {
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("actions").doc("user").collection(u.user.to.uid);
      // eslint-disable-next-line
      dbUserActions.doc(u.basic.did).set(u).then(function(docRef) {
          // success user created and now update doc. id (did)
          // eslint-disable-next-line
          // db.doc(docRef.id).update({'did': docRef.id});
        });
    },
    getActionSource(u) {
      this.enableSpinnerGetActionSource = true;
      console.log(" *** Get Action Source ***");
      console.log(u);
      // eslint-disable-next-line
      if (u.ipac.otyp === "risk") {
        // eslint-disable-next-line
        var db = firebase.firestore().collection("management").doc(u.ipac.cn).collection(u.ipac.fn).doc("Management").collection("Risks");
      }
      if (u.ipac.otyp === "ms") {
        // eslint-disable-next-line
        var db = firebase.firestore().collection("management").doc(u.ipac.cn).collection(u.ipac.fn).doc("Maintenance").collection("Strategy");
      }
      // eslint-disable-next-line
      db.where("basic.did", "==", u.ipac.odid).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let r = doc.data();
            // attachment / action is common
            this.$store.dispatch("changeActionList", r.action);
            this.$store.dispatch("changeAttachmentList", r.attach);
            this.$store.dispatch("changeRolesList", r.roles);
            // if RISK
            if (u.ipac.otyp === "risk") {
              this.$store.dispatch("changeROList", r.ro);
              this.$store.dispatch("changeRisk", r);
              // go to risk edit
              this.$router.push("/riskedit");
            }
            // if MAINTENANCE STRATEGY
            if (u.ipac.otyp === "ms") {
              // this.$store.dispatch("changeMaintStrategyLisr", r.ro);
              this.$store.dispatch("changeMaintStrategy", r);
              // go to risk edit
              this.$router.push("/maintstrategyedit");
            }

            // console.log(doc.data());
          });
        });
    },
    updateUserActionStatus(u) {
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("actions").doc("user").collection(u.user.to.uid);
      // eslint-disable-next-line
        dbUserActions.doc(u.basic.did).update({
          "basic.status": u.basic.status
        })
        // eslint-disable-next-line
        .then( (data) => {
          // reset store
          // this.$store.dispatch("changeFacilityUsers", []);
        });
    },
    updateUserAction(u) {
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("actions").doc("user").collection(u.user.to.uid);
      // eslint-disable-next-line
        dbUserActions.doc(u.basic.did).set(u)
        // eslint-disable-next-line
        .then( (data) => {
          // reset store
          // this.$store.dispatch("changeFacilityUsers", []);
        });
    },
    deleteUserAction(u) {
      // eslint-disable-next-line
      const dbUserActions = firebase.firestore().collection("actions").doc("user").collection(u.user.to.uid);
      // eslint-disable-next-line
        dbUserActions.doc(u.basic.did).delete()
        // eslint-disable-next-line
        .then( (data) => {
          // reset store
          // this.$store.dispatch("changeFacilityUsers", []);
        });
    },
    distributeActionList() {
      // MS ACTIONS ASSIGNED FOR USER
      if (this.getActionList.length > 0) {
        let al = this.getActionList;
        let temp = {};
        // if (u === "ms") {
        //   temp = this.getMaintStrategy;
        // }
        // only send the actions to the users
        // that have status 'crit'
        // 'sent' status - do nothing for user
        for (var i = 0; i < al.length; i++) {
          if (temp.action[i].basic.status === "unsent") {
            temp.action[i].basic.status = "sent";
            // send individual actions to users
            this.createActionForUser(temp.action[i]);
          } else if (temp.action[i].basic.status === "cancel") {
            temp.action[i].basic.status = "cancel";
            // send individual actions to users
            this.updateUserActionStatus(temp.action[i]);
          } else if (temp.action[i].basic.status === "submit") {
            // send individual actions to users
            this.updateUserActionStatus(temp.action[i]);
          } else if (temp.action[i].basic.status === "resent") {
            // send individual actions to users
            this.updateUserActionStatus(temp.action[i]);
            // eslint-disable-next-line
          } else if (temp.action[i].basic.status === "resubmit") {
            // send individual actions to users
            this.updateUserActionStatus(temp.action[i]);
          } else if (temp.action[i].basic.status === "close") {
            // send individual actions to users
            this.updateUserActionStatus(temp.action[i]);
          }
        }
        // update local action to store
        this.$store.dispatch("changeActionList", temp.action);
      }
    }
  }
};
